import {isArray} from './array';

/*
|--------------------------------------------------------------------------
| Methoden, welche mit Objekten arbeiten und diese manipulieren.
|--------------------------------------------------------------------------
|
 */

/**
 * Check of es sich um ein Object handelt
 * @param  mixed  obj
 * @return {Boolean}
 */
export function isObject(obj) {
	 return obj === Object(obj);
}

/**
 * Objekt reduzieren
 * @param  Function func
 * @param  acc
 * @param  Object obj
 * @return Array
 */
export function oreduce(func, acc, obj){
  	Object.keys(obj).reduce((acc, key) => func(acc, obj[key], key, obj), acc);
}

/**
 * Holt die Values eines Objektes und gibt diese als Array zurück
 * @param  Object obj
 * @return Array
 */
export function oValues(obj){
	let vals = [];
	for (var key in obj) {
		if (obj.hasOwnProperty(key) && obj.propertyIsEnumerable(key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
}

/**
 * Ein Object durch andere Objekte erweitern. Diese werden angehangen.
 * @param  Object target Zielobject
 * @return Object
 */
export function oExtend(target) {
    for (let i = 1; i < arguments.length; ++i) {
        let from = arguments[i];

        if (typeof from !== 'object') {
            continue;
        }

        for(let j in from) {
            if(from.hasOwnProperty(j)) {
                target[j] = (from[j] === Object(from[j]) && !isArray(from[j]))
                ? oExtend({}, target[j], from[j])
                : from[j];
            }
        }
    }
    return target;
}

export const oFlatten = ob => {
    var toReturn = {};

    for (var i in ob) {
        if (!ob.hasOwnProperty(i)) continue;

        if ((typeof ob[i]) == 'object') {
            var flatObject = oFlatten(ob[i]);
            for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue;

                toReturn[i + '.' + x] = flatObject[x];
            }
        } else {
            toReturn[i] = ob[i];
        }
    }
    return toReturn;
};

/**
 * Checkt, ob zwei Objects gleich sind
 * @param  Object x
 * @param  Object y
 * @return boolean
 */
export function oEqual(x, y) {
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === 'object' && tx === ty ? (
        ok(x).length === ok(y).length &&
        ok(x).every(key => oEqual(x[key], y[key]))
    ) : (x === y);
}

/**
 * Prüft, ob ein Objekt leer ist {}
 * @param  Object obj
 * @return Boolean
 */
export function oIsEmpty(obj){
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

/**
 * Deep access object with dot-notation
 * @param  array keys
 * @return mixed
 */
export function oGet(object, key, def = null) {
    if (!isObject(object)) {
        throw new Error('No object passed!');
    }

    // No dot notation
    if (key.indexOf('.') === -1) {
        return object[key] || def;
    }

    const keyArray = key.split('.');
    const firstKey = keyArray.shift();
    const newKey = keyArray.join('.');

    return oGet(object[firstKey], newKey, def);
}
